import { render, staticRenderFns } from "./WorkflowTestProcessEdit.vue?vue&type=template&id=67182e25"
import script from "./WorkflowTestProcessEdit.vue?vue&type=script&lang=js"
export * from "./WorkflowTestProcessEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports